// Import environment configuration first
import "./config";

// Register third-party tracking services after config is loaded
import { registerGTM } from "./registerGTM";
// import { registerMixpanel } from "./registerMixpanel";

// Initialize tracking services
registerGTM();
// registerMixpanel();

import VueMask from "v-mask";
import { VMoney } from "v-money";
import Vue from "vue";
import store from "./store.js";
import router, { KEVI_MAINTENANCE_MODE } from "./router";
import "./resource";
import { directive as LangDirective, getTranslator, t } from "./languages";
import {
    getRouteLang,
    getStoredLang,
    persistLang,
    resolveInitialLang,
} from "./langPreference";
import { Settings } from "luxon";
import currencyMixin from "./mixins/currency-mixin";

Settings.defaultLocale = "pt-br";
Vue.directive("lang", LangDirective);
Vue.directive("money", VMoney);

require("./global-components");
require("./chat");

Vue.use(VueMask, {
    placeholders: {
        D: /[\d-]/, // define new placeholder
    },
});

const translateForVm = (vm, term, replaces) => {
    const lang =
        vm?.$root?.lang ||
        vm?.lang ||
        getRouteLang(router.currentRoute) ||
        getStoredLang() ||
        "ptBr";

    return t(term, lang, replaces);
};

Vue.prototype.$module = store.getters.module;
Vue.prototype.$pointsProgram = store.getters.pointsProgram;
Vue.prototype.$_ = getTranslator("ptBr");
Vue.prototype.$t = function (term, replaces) {
    return translateForVm(this, term, replaces);
};
Vue.mixin({
    methods: {
        t(term, replaces) {
            return this.$t(term, replaces);
        },
    },
});
Vue.mixin(currencyMixin);

var logged = store.state.user.id && store.state.user.token ? true : false;

if (logged) {
    store.dispatch("updateUserInfo");
}

let app = new Vue({
    store,
    router: router,
    data: function () {
        return {
            lang: resolveInitialLang(router.currentRoute),
        };
    },
    created() {
        this.applyLang(this.lang);
        this.syncLangFromRoute(this.$route);
        this.handleScreenResize();
        window.addEventListener("resize", this.handleScreenResize);
    },
    computed: {
        showOtherPlacesData() {
            return this.$store.state.showOtherPlacesData;
        },
        isMaintenanceMode: function () {
            return KEVI_MAINTENANCE_MODE;
        },
        showHeader: function () {
            if (KEVI_MAINTENANCE_MODE) return false;
            return this.$store.state.user.token ? true : false;
        },
        isLoggedIn: function () {
            if (KEVI_MAINTENANCE_MODE) return false;
            return this.$store.state.user.token ? true : false;
        },
        notifications: function () {
            return this.$store.state.notification.notifications;
        },
        pageContentClass: function () {
            let pageClass = "page-content ";
            const firstMatchPath =
                this.$route &&
                Array.isArray(this.$route.matched) &&
                this.$route.matched[0] &&
                this.$route.matched[0].path
                    ? this.$route.matched[0].path
                    : (this.$route && this.$route.path) || "";
            pageClass += String(firstMatchPath || "root")
                .replace(/[\/]/g, "-")
                .replace(/^[-]+/g, "")
                .replace(/[:]/g, "");
            if (this.showHeader) {
                pageClass += " has-header";
            }
            if (this.user.global_admin) {
                pageClass += " global-admin";
            }
            return pageClass;
        },
        user: function () {
            return { ...this.$store.state.user };
        },
        place: function () {
            return { ...this.$store.state.place };
        },
    },
    methods: {
        t: function (term, replaces) {
            return translateForVm(this, term, replaces);
        },
        applyLang(lang) {
            this.lang = lang;
            Vue.prototype.$_ = getTranslator(lang);
            persistLang(lang);
        },
        syncLangFromRoute(route) {
            const queryLang = getRouteLang(route);
            if (queryLang && queryLang !== this.lang) {
                this.applyLang(queryLang);
                return;
            }
            if (!queryLang) {
                const storedLang = getStoredLang();
                if (storedLang && storedLang !== this.lang) {
                    this.applyLang(storedLang);
                }
            }
        },
        errorImage(event, newSrc = "images/kevi.png") {
            event.target.src = newSrc;
            if (window.appMode == "production") {
                console.clear();
            }
        },
        handleScreenResize() {
            const width = window.innerWidth;
            this.$store.commit("setScreen", {
                width: width,
                isMobile: width <= 768,
            });
        },
    },
    watch: {
        $route: function (to) {
            this.syncLangFromRoute(to);
        },
        user: function (newUser, oldUser) {
            if (oldUser.token && oldUser.token !== newUser.token) {
                window.location.reload(false);
                if (this.user.id) {
                    this.$store.dispatch("setUser", this.user);
                    return;
                }
                window.mixpanel?.reset();
            }
        },
        place: function (newPlace, oldPlace) {
            if (oldPlace.id && oldPlace.id !== newPlace.id) {
                window.location.reload(false);
            }
        },
    },
}).$mount("#app");
